class Device {
  constructor() {
    this.volume_ = null
    this.muted_ = null
    this.powerState = null
    this.numpad = true
  }
  async _init() {
    this.volume()
    this.mute()

    _$.vue.$emit("volume", { volume: this.volume_, activate: false })

    document.addEventListener("nv-vol_up", () => this.volume(this.volume_ + 1))
    document.addEventListener("nv-vol_down", () => this.volume(this.volume_ - 1))
    document.addEventListener("nv-mute", () => this.mute(true))

    setInterval(() => this.getPowerState(true), 2000)
    setInterval(() => this.mute(), 2000)
    return true
  }

  async properties() {
    const macAddress = MacId.getMacId()
    const ipAddress = await __._api.execute("get_IP_address").then(res => res.trim().replace(/^.*IPaddr:\s*((?:\d{1,3}\.){3}\d{1,3}).*$/, "$1"))
    const serial = await __._api.execute("GETSERIALNO").then(res => res.trim())
    const firmware = await __._api.execute("GETSWVERSION").then(res => res.trim())
    const software = await __._api.execute("BUILDINFO").then(res => res.trim().replace(/^.*?\[([^\]]+)\].*$/, "$1"))
    const model = navigator.userAgent.match(/VSTVB ([A-Za-z0-9._-]+)/).pop()

    const properties = {
      mac: macAddress,
      ip: ipAddress,
      serial: serial || "000000",
      firmware: firmware,
      software: software,
      manufacturer: "Vestel",
      product: model,
      type: "vestel"
    }

    const res = Object.keys(properties).every(key => properties[key] || false)

    return res && properties
  }
  async baseUrl() {
    try {
      return JSON.parse(playmore.platform.getConfigAll("private")).url
    } catch (error) {
      return location.origin
    }
  }
  async getKeyMap() {
    return [
      // Controllers
      [37, "left"],
      [38, "up"],
      [39, "right"],
      [40, "down"],
      [13, "enter"],
      [461, "back"],
      [-1, "exit"],
      [447, "vol_up"],
      [448, "vol_down"],
      [449, "mute"],

      // Player Controller
      [677, "play"],
      [19, "pause"],
      [-1, "toggle"],
      [413, "stop"],
      [417, "fw"],
      [412, "rw"],
      [-1, "prev"],
      [-1, "next"],

      // TV
      //[92, "ch_up"],
      //[93, "ch_down"],
      [427, "ch_up"],
      [428, "ch_down"],
      [679, "tv"], //Register
      [-1, "subtitle"], //Register
      [-1, "list"], //Register
      [-1, "epg"],
      [-1, "switch"],
      [-1, "favorite"],

      // General
      [-1, "info"],
      [-1, "settings"], //Register
      [-1, "alarm-clock"],
      [-1, "sleep-timer"],
      [444, "source"], //Register
      [-1, "power"],
      [407, "home"], //Register
      [-1, "refresh"], //Register

      [403, "red"],
      [404, "green"],
      [458, "yellow"],
      [406, "blue"],

      // Numpad
      [48, "numpad", 0],
      [49, "numpad", 1],
      [50, "numpad", 2],
      [51, "numpad", 3],
      [52, "numpad", 4],
      [53, "numpad", 5],
      [54, "numpad", 6],
      [55, "numpad", 7],
      [56, "numpad", 8],
      [57, "numpad", 9],

      // Applications
      [-1, "youtube"],
      [-1, "netflix"],
      [-1, "prime"],
      [-1, "spotify"],
      [-1, "browser"],
      [-1, "cast"],
      [-1, "movies"],
      [-1, "musics"],
      [-1, "usb"],
      [-1, "shahid"]
    ]
  }
  async setName(name) {
    let res = await __._api.execute("SETWIFIAPSTATE off")
    res = await __._api.execute(`SETWIFIAPSSID ${name}`)

    return res.trim().replace(/.*\(([^)]+)\).*/, "$1")
  }
  async getName() {
    const res = await __._api.execute(`GETWIFIAPSSID`)
    return res.trim().replace(/.*\(([^)]+)\).*/, "$1")
  }

  /* Register Methods */
  async registerKeys() {
    var keys = []
    for (var i = 0; i < 1000; i++) {
      keys.push(i)
    }
    keys.splice(keys.indexOf(409), 1)
    ApplicationManager.getCSPWindow().keySet.setValue(2047, keys)

    return true
  }

  /* Volume Management */
  async volume(volume) {
    if (typeof volume !== "number") this.volume_ = parseInt(SoundSettings.getVolumeLevel())
    else {
      this.volume_ = parseInt(volume)
      if (this.volume_ > 100) this.volume_ = 100
      else if (this.volume_ < 0) this.volume_ = 0

      SoundSettings.setVolumeLevel(this.volume_)
      _$.vue.$emit("volumeChanged", this.volume_)
    }

    return this.volume_
  }
  async mute(value) {
    if (["boolean", "number"].indexOf(typeof value) >= 0) {
      if (__.device.properties.product === "MB100") {
        const vol = parseInt(SoundSettings.getVolumeLevel())
        if (!vol) SoundSettings.setVolumeLevel(this.volume_)
        else SoundSettings.setVolumeLevel(0)

        this.muted_ = !vol ? false : true
      } else {
        let muted = await __._api.execute("SETMUTE").then(res => res.trim().replace("MUTE ", ""))
        muted = muted === "ON"

        const diff = this.muted_ !== muted
        if (diff) _$.vue.$emit("volume", { muted })

        this.muted_ = muted
      }
    } else {
      if (__.device.properties?.product === "MB100") return this.muted_

      let muted = await __._api.execute("GETMUTE").then(res => res.trim().replace("MUTE ", ""))
      muted = muted === "ON"

      const diff = this.muted_ !== muted
      if (diff) _$.vue.$emit("mute", muted)

      this.muted_ = muted
    }

    return this.muted_
  }
  async maxVolume() {
    _$.vue.$on("volumeChanged", event => {
      _$.vue.$emit("volume", { volume: event })
      if (event > __.device.maxVolume) __.device.volume(__.device.maxVolume)
    })
    return true
  }

  /* Power Management */
  async getPowerState(event_ = false) {
    let powerState = StandbyController.isDeviceInActiveStandby()
    powerState = powerState ? "standby" : "on"

    const diff = this.powerState !== powerState

    this.powerState = powerState
    if (event_ && diff) _$.handler.emit("power_mode_changed", powerState)
    return powerState
  }
  async powerOn() {
    return StandbyController.quitActiveStandby()
  }
  async standBy() {
    return StandbyController.enterActiveStandby()
  }
  async reboot() {
    return __._api.execute("RST", false)
  }
  async clearData() {
    return __._api.execute("CLEARPRIVATEDATA")
  }

  /* Soft AP */
  async getSoftAP() {
    const ssid = await __._api.execute(`GETWIFIAPSSID`).then(res => res.trim().replace(/^.*\(([^)]+)\).*$/, "$1"))
    const password = await __._api.execute(`GETWIFIAPSECURITYPASSWORD`).then(res => res.trim().replace(/^.*\(([^)]+)\).*$/, "$1"))
    const status = await __._api.execute(`GETWIFIAPSTATE`).then(res => (res.includes("not active") ? false : true))

    return {
      ssid: ssid,
      password: password,
      status: _$.true(status)
    }
  }
  async enableSoftAP() {
    return __._api.execute(`SETWIFIAPSTATE on`)
  }
  async disableSoftAP() {
    return __._api.execute(`SETWIFIAPSTATE off`)
  }
  async isSoftAPEnabled() {
    return __._api.execute(`GETWIFIAPSTATE`).then(res => (res.includes("not active") ? false : true))
  }
}

export default Device
